import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

const VersionCheck = () => {
    const [showModal, setShowModal] = useState(false);
    const [newVersion, setNewVersion] = useState(null);

    useEffect(() => {
        // Initial check
        checkVersion();

        // Set interval for periodic checks (every 15 minutes)
        const intervalId = setInterval(() => {
            checkVersion();
        }, 15 * 60 * 1000); // 15 minutes in milliseconds

        // Cleanup interval on unmount
        return () => clearInterval(intervalId);
    }, []);

    const checkVersion = async () => {
        try {
            // Fetch version.json with cache busting
            const response = await fetch(`/version.json?t=${Date.now()}`);
            const data = await response.json();
            const serverVersion = data.version;

            // Get stored version from localStorage
            const storedVersion = localStorage.getItem('app_version');

            // If no stored version, save current version
            if (!storedVersion) {
                localStorage.setItem('app_version', serverVersion);
                return;
            }

            // If versions don't match, show modal
            if (storedVersion !== serverVersion) {
                setNewVersion(serverVersion);
                setShowModal(true);
            }
        } catch (error) {
            console.warn('Error checking version:', error);
        }
    };

    const handleRefresh = () => {
        // Save new version to localStorage
        if (newVersion) {
            localStorage.setItem('app_version', newVersion);
        }

        // Force refresh without cache
        window.location.reload(true);
    };

    return (
        <Modal show={showModal} backdrop="static" keyboard={false} centered>
            <Modal.Header>
                <Modal.Title>{'Aggiornamento Disponibile'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{'È disponibile una nuova versione dell\'applicazione. Per utilizzare le nuove funzionalità è necessario ricaricare la pagina.'}</p>
                {newVersion && (
                    <p className="text-muted">
                        <small>{'Nuova versione'}: <strong>{newVersion}</strong></small>
                    </p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleRefresh}>
                    {'Ricarica Ora'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default VersionCheck;
